import React, { useEffect, useState, Component } from 'react';
import ReactDOM from 'react-dom';
import { useParams, Link } from 'react-router-dom';
import StackGrid from "react-stack-grid";
import InnerImageZoom from 'react-inner-image-zoom';
import 'react-inner-image-zoom/lib/InnerImageZoom/styles.css';
import useWindowDimensions from './hooks/useWindowDimensions.js';

// get request from GraphQL
import { request } from 'graphql-request';

// Import QR Code:
// https://www.npmjs.com/package/react-qr-code
import QRCode from "react-qr-code";

// Import Carousel:
// https://github.com/leandrowd/react-responsive-carousel
// import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
// import { Carousel } from 'react-responsive-carousel';

// Import New Carousel
//
// import Carousel, { Dots } from '@brainhubeu/react-carousel';
// import '@brainhubeu/react-carousel/lib/style.css';

// Import Keen Slider
import 'keen-slider/keen-slider.min.css'
import { useKeenSlider } from 'keen-slider/react'

import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'


// Photoswiper
import 'photoswipe/dist/photoswipe.css'
import 'photoswipe/dist/default-skin/default-skin.css'
import { Gallery, Item } from 'react-photoswipe-gallery'


function Car({ cars, gallery }) {

    const { slug } = useParams();
    const car = cars.find((car) => car.slug === slug);
    // useEffect(() => {
    //     window.scrollTo(0, 0)
    // }, [])
    //setShowIndex(false);





// ====================================================== //
// ===================== PHOTOSWIPER ==================== //
// ====================================================== //

        const MyGallery = () => (
            <Gallery shareButton={false}>
                <StackGrid
                    columnWidth="33%"
                    gutterWidth={10}
                    gutterHeight={10}
                    monitorImagesLoaded={true}
                >
                {
                    car.gallery.map(({ id, rawURL, thumbnailURL, url, largeURL, smallURL, imgW, imgH, handle}, i) => (
                        <div key={`key` + i}>
                            <Item
                                thumbnail={thumbnailURL}
                                original={largeURL}
                                width={imgW}
                                height={imgH}
                                >
                                {({ ref, open }) => (
                                <img ref={ref} onClick={open} src={thumbnailURL}/>
                                )}
                            </Item>
                        </div>
                    ))
                }
                </StackGrid>
            </Gallery>
        )


        return (
            <>

                <div class="hide-from-carousel" id="main">
                {
                    window.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: 'smooth'
                })}
                {car.showcaseImage ?
                    <>
                    <div className='ccCar'>
                        <img src={car.showcaseImage.url} alt={car.title} className="featureImageHighRes"/>
                        <img src={car.showcaseImageTiny.url} alt={car.title} className="featureImageLowRes"/></div>
                    </>
                :
                    null
                }

                <h1>
                    <div className="label-year">{car.year}</div>
                    <div className="make-model">{car.make} {car.model}</div>
                </h1>
                <ul className="specs">
                    {/* <div class="qr"><QRCode size="65" value={'https://edge-motor-museum-web.web.app/cars/' + car.slug} /></div> */}
                    <h2>Full Specs</h2>
                    <li className="year"> <div className="dt">Year: </div> <div className="dd">{car.year}</div> </li>
                    <li className="make"> <div className="dt">Make: </div> <div className="dd">{car.make}</div> </li>
                    <li className="model"> <div className="dt">Model: </div> <div className="dd">{car.model}</div> </li>
                    <li className="engine"> <div className="dt">Engine: </div> <div className="dd">{car.engine}</div> </li>
                    <li className="horsepower"> <div className="dt">Horsepower: </div> <div className="dd">{car.horsepower}</div> </li>
                    <li className="fuelDelivery"> <div className="dt">FuelDelivery: </div> <div className="dd">{car.fuelDelivery}</div> </li>
                    <li className="transmission"> <div className="dt">Transmission: </div> <div className="dd">{car.transmission}</div> </li>
                </ul>
                <div className="story" style={{whiteSpace: "pre-wrap"}}>
                    <p>{car.story}</p>
                </div>

                </div>
                {/* <ThumbnailGrid /> */}
                {/* <EdgeCarousel /> */}
                <div class="gallery-wrapper">
                    <h2>Gallery</h2>
                    <div class="gallery-padding">
                        <MyGallery/>
                    </div>
                </div>


            </>
        );
    }
export default Car;
